import { useState } from "react";
import Input from "../../../design/Input";
import cleanAndFormatNumber from "./cleanAndFormatNumber";
import "./AccountNames.css";


function AccountNames ({sum, sumR, selectRadio, setSelectRadio, namesPaid, names}) {

    const [selectForAll, setSelectForAll] = useState(false);
    const [namesFilter, setNamesFilter] = useState(names);
    const [inputNamesFilter, setInputNamesFilter] = useState("");

    const inputFilter = (value) => {
        setInputNamesFilter(value);

        let filteredNames = {};

        Object.keys(names).map((nameValue) => {
            if (names[nameValue]['name'].toLowerCase().includes(value.toLowerCase())) {
                filteredNames[nameValue] = names[nameValue];
            }
        })

        setNamesFilter(filteredNames);
    }
    
    const clickForAll = () => {
        let selected = !selectForAll;
        const radio = Object.fromEntries(Object.keys(selectRadio).map(key => [key, {select: selected, radio: '1'}]));
        setSelectForAll(selected);
        setSelectRadio(radio);
    }

    function clickOfNames (key) {
        setSelectRadio({...selectRadio, [key]: {...selectRadio[key], select: !selectRadio[key]['select']}});
    }

    function clickRadio (key, event) {
        setSelectRadio({...selectRadio, [key]: {...selectRadio[key], radio: event.target.value}});
    }

    return (<>
        <div className="account-aufa-names-head">
            <div>
                <label htmlFor="select-all">בחר\בטל הכל</label>
                <input type={"checkbox"} id="select-all" onChange={clickForAll} checked={selectForAll} />
            </div>
            <Input textView={'חיפוש'} myStyle={'input3'} value={inputNamesFilter} onChange={inputFilter} />
        </div>

        <div className="account-aufa-names-main">
            {
                Object.keys(namesFilter).map((numName, key) => (
                    <div key={key}>
                        <div>
                            <input type={'checkbox'} id={`select-name-${key}`} checked={selectRadio[numName]['select']} onChange={() => {clickOfNames(numName)}} />
                            <label htmlFor={`select-name-${key}`}> {names[numName]['name']} </label>
                        </div>

                        <div>
                            {
                                (!(numName in namesPaid) || sum - namesPaid[numName] > 0) && (
                                    <div>
                                        <input type={'radio'} name={`option${key}`} id={`radio-name-1-${key}`} value={'1'}
                                        checked={selectRadio[numName]['select'] && (selectRadio[numName]['radio'] == '1')}
                                        onChange={(event) => {clickRadio(numName, event)}}
                                        />

                                        <label htmlFor={`radio-name-1-${key}`}>
                                            {cleanAndFormatNumber(numName in namesPaid ? sum - namesPaid[numName] : sum)}$
                                        </label>
                                    </div>
                                )
                            }

                            {
                                (!(numName in namesPaid) || sumR - namesPaid[numName] > 0) && (
                                    <div>
                                        <input type={'radio'} name={`option${key}`} id={`radio-name-2-${key}`} value={'2'} 
                                        checked={selectRadio[numName]['select'] && (selectRadio[numName]['radio'] == '2')}
                                        onChange={(event) => {clickRadio(numName, event)}}
                                        />

                                        <label htmlFor={`radio-name-2-${key}`}>
                                            {cleanAndFormatNumber(numName in namesPaid ? sumR - namesPaid[numName] : sumR)}$
                                        </label>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                ))
            }
        </div>
    </>)
}

export default AccountNames;